import {
  IMG_AIRPORT_GIMHAE_1,
  IMG_AIRPORT_GIMPO_1,
  IMG_AIRPORT_GIMPO_2,
  IMG_AIRPORT_INCHEON_1,
  IMG_AIRPORT_INCHEON_2,
  IMG_AIRPORT_JEJU_1,
} from '@repo/assets';
import { AIRPORT_VALUE, VAN_REFUNDABLE_AIRPORT_CODE } from '@repo/types';
import { Icon } from '@successmode-ktp/kui';
import styled from 'styled-components';

export const REFUNDABLE_AIRPORT_LIST: AIRPORT_VALUE[] = [
  'Incheon Airport',
  'Gimpo Airport',
  'Gimhae Airport',
  'Jeju Airport',
];

export const VAN_REFUNDABLE_AIRPORT_CODE_LIST: VAN_REFUNDABLE_AIRPORT_CODE[] = [
  'ICN_TERMINAL1',
  'ICN_TERMINAL2',
  'GMP',
  'KIH',
  'CJU',
  'VAN_ETC',
];

export const AIRPORT_LIST = [
  {
    id: 'ICN_TERMINAL1',
    value: 'Incheon Airport',
    label: 'Incheon Airport',
    korLabel: '인천국제공항',
  },
  {
    id: 'GMP',
    value: 'Gimpo Airport',
    label: 'Gimpo Airport',
    korLabel: '김포국제공항',
  },
  {
    id: 'KIH',
    value: 'Gimhae Airport',
    label: 'Gimhae Airport',
    korLabel: '김해공항',
  },
  {
    id: 'CJU',
    value: 'Jeju Airport',
    label: 'Jeju Airport',
    korLabel: '제주공항',
  },
  {
    id: 'ETC',
    value: 'ETC',
    label: 'ETC',
    korLabel: '그 외',
  },
] as const;

export const SELECT_LIST = [
  {
    id: 'ICN_TERMINAL1',
    value: 'Incheon Airport',
    label: 'Major Airport',
    korLabel: '주요공항',
  },
  {
    id: 'ETC',
    value: 'ETC',
    label: 'ETC',
    korLabel: '그 외 공항',
  },
  {
    id: 'CRUISE',
    value: 'Cruise',
    label: 'Cruise',
    korLabel: '크루즈',
  },
] as const;

export const AIRPORT_CUSTOMS_LOCATION_LIST = [
  {
    id: 'Incheon Airport Terminal 1',
    label: 'Incheon Airport Terminal 1 (3F)',
    korLabel: '인천국제공항 1터미널 (3층)',
    image: IMG_AIRPORT_INCHEON_1,
  },
  {
    id: 'Incheon Airport Terminal 2',
    label: 'Incheon Airport Terminal 2 (3F)',
    korLabel: '인천국제공항 2터미널 (3층)',
    image: IMG_AIRPORT_INCHEON_2,
  },
  {
    id: 'Gimpo Airport Airport 2F',
    label: 'Gimpo International Airport (2F)',
    korLabel: '김포국제공항 터미널 (2층)',
    image: IMG_AIRPORT_GIMPO_1,
  },
  {
    id: 'Gimpo Airport Airport 3F',
    label: 'Gimpo International Airport (3F)',
    korLabel: '김포국제공항 터미널 (3층)',
    image: IMG_AIRPORT_GIMPO_2,
  },
  {
    id: 'Gimhae Airport',
    label: 'Gimhae  International Airport (2F)',
    korLabel: '김해국제공항 (2층)',
    image: IMG_AIRPORT_GIMHAE_1,
  },
  {
    id: 'Jeju Airport',
    label: 'Jeju International Airport (3F)',
    korLabel: '제주국제공항 (3층)',
    image: IMG_AIRPORT_JEJU_1,
  },
];

export const getRefundType = (
  nationality: string | undefined,
  id: VAN_REFUNDABLE_AIRPORT_CODE,
) => {
  if (id === 'ICN_TERMINAL1') {
    if (nationality === 'KOR') {
      return '인천공항 1터미널';
    }
    return 'Incheon Airport T1';
  }

  if (id === 'ICN_TERMINAL2') {
    if (nationality === 'KOR') {
      return '인천공항 2터미널';
    }
    return 'Incheon Airport T2';
  }

  if (id === 'GMP') {
    if (nationality === 'KOR') {
      return '김포국제공항';
    }
    return 'Gimpo Airport';
  }

  if (id === 'KIH') {
    if (nationality === 'KOR') {
      return '김해공항';
    }
    return 'Gimhae Airport';
  }

  if (id === 'CJU') {
    if (nationality === 'KOR') {
      return '제주공항';
    }
    return 'Jeju Airport';
  }

  if (id === 'KIOSK') {
    if (nationality === 'KOR') {
      return 'KTP 환급 키오스크';
    }
    return 'KTP Refund Kiosk';
  }

  if (id === 'VAN_ETC') {
    if (nationality === 'KOR') {
      return '공항에서 환급받음';
    }
    return 'Received a tax refund\nat the airport';
  }

  return '-';
};

const ArrowButton = styled.button`
  position: fixed;
  top: 65%;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  border-radius: 100px;
  filter: drop-shadow(0px 0px 10px rgba(0, 0, 0, 0.15));
  background-color: #fff !important;
  z-index: 300;

  &::before {
    content: '';
  }

  &:hover {
    opacity: 1 !important;
  }
`;

const PrevButton = styled(ArrowButton)`
  left: 10px;
`;

const NextButton = styled(ArrowButton)`
  right: 10px;
`;

export const getBillSliderSetting = ({
  length,
  showIndex,
  setCurrentSlide,
}: {
  length: number;
  showIndex: number;
  setCurrentSlide?: (index: number) => void;
}) => {
  return {
    dots: false,
    speed: 500,
    initialSlide: showIndex,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerPadding: '0px',
    infinite: false,
    arrows: true,
    centerMode: true,
    nextArrow: (
      <NextButton>
        <Icon.ChevronRight size={24} fillColor='#111111' />
      </NextButton>
    ),
    prevArrow: (
      <PrevButton>
        <Icon.ChevronLeft size={24} fillColor='#111111' />
      </PrevButton>
    ),
    beforeChange: (current: number, next: number) =>
      setCurrentSlide ? setCurrentSlide(next) : undefined,
  };
};
